import { EXPRESS_API } from 'configs/api/expressApi';
import { useAuth } from 'lib/context';
import { useToastError } from 'lib/hooks/useToastError';
import { useMutation, useQueryClient } from 'react-query';
import { notificationKeys } from './queryKeys';

// this endpoint returns the results of updating the notification not the notification
const readAllNotifications = async (): Promise<any> => {
  return (await EXPRESS_API.put(`notification/readAll`)).data;
};

export const useReadAllNotificationMutation = () => {
  const queryClient = useQueryClient();
  const { showError } = useToastError();
  const { invalidateNotificationCount } = useAuth();

  return useMutation(readAllNotifications, {
    onError: err => showError(err),
    onSuccess: async () => {
      await queryClient.invalidateQueries(notificationKeys.all());
      await invalidateNotificationCount();
    },
  });
};
